export default __webpack_public_path__ + "static/media/33-lead.d82a50dd.png";